export const showModal = (context, payload, done) => {
    context.dispatch('SHOW_MODAL', payload);
    done();
};

export const hideModal = (context, payload, done) => {
    context.dispatch('HIDE_MODAL', payload);
    done();
};



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/modal-store-actions.js